import { render, staticRenderFns } from "./file-container.vue?vue&type=template&id=05fe206f&scoped=true&"
import script from "./file-container.vue?vue&type=script&lang=js&"
export * from "./file-container.vue?vue&type=script&lang=js&"
import style0 from "./file-container.vue?vue&type=style&index=0&id=05fe206f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe206f",
  null
  
)

export default component.exports